window.NupzCart = (function () {
var cache = null;
var lastFetch = 0;
var CACHE_MS = 400;
var pending = null;
function fetchFresh() {
pending = fetch('/cart.js?_=' + Date.now(), {
cache: 'no-store',
headers: { 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Pragma': 'no-cache' },
})
.then(function (r) { return r.json(); })
.then(function (cart) {
cache = cart;
lastFetch = Date.now();
pending = null;
document.dispatchEvent(new CustomEvent('nupz:cart-updated', { detail: cart }));
return cart;
});
return pending;
}
function get() {
if (pending) return pending;
if (cache && (Date.now() - lastFetch) < CACHE_MS) {
return Promise.resolve(cache);
}
return fetchFresh();
}
function refresh() {
return fetchFresh();
}
document.addEventListener('submit', function (e) {
if (e.target.matches('form[action*="/cart/add"]') || e.target.matches('form[data-type="add-to-cart-form"]')) {
setTimeout(refresh, 400);
}
});
document.addEventListener('click', function (e) {
if (e.target.closest('.quantity__button, cart-remove-button, [href*="/cart/change"], a[href*="/cart/clear"]')) {
setTimeout(refresh, 200);
setTimeout(refresh, 700);
setTimeout(refresh, 1300);
setTimeout(refresh, 2200);
setTimeout(refresh, 4000);
}
});
document.addEventListener('change', function (e) {
if (e.target.matches('.quantity__input, input[name="quantity"]')) {
setTimeout(refresh, 200);
setTimeout(refresh, 700);
setTimeout(refresh, 1300);
}
});
function watchCartDom() {
var target = document.querySelector('cart-items, .cart-items, #main-cart-items, [id^="CartDrawer"], [id^="cart-icon-bubble"]');
if (!target) return;
var observer = new MutationObserver(function () {
refresh();
});
observer.observe(target, { childList: true, subtree: true });
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', watchCartDom);
} else {
watchCartDom();
}
setInterval(refresh, 400);
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
try {
subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
if (event && event.cartData) {
cache = event.cartData;
lastFetch = Date.now();
document.dispatchEvent(new CustomEvent('nupz:cart-updated', { detail: event.cartData }));
} else {
refresh();
}
});
} catch (e) {
}
}
return { get: get, refresh: refresh };
})();
(function () {
var SELECTOR = '.nupz-hero__img, .slideshow__media img, .slideshow__image, .banner img, .hero img';
var BRUSH_RADIUS = 20;
var FADE_ALPHA = 0.05;
function injectFilter() {
if (document.getElementById('nupz-color-smear')) return;
var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
svg.setAttribute('width', '0');
svg.setAttribute('height', '0');
svg.style.position = 'absolute';
svg.innerHTML =
'<filter id="nupz-color-smear">' +
'<feTurbulence type="fractalNoise" baseFrequency="0.01 0.04" numOctaves="2" seed="7" result="noise">' +
'<animate attributeName="baseFrequency" values="0.01 0.04;0.014 0.05;0.01 0.04" dur="6s" repeatCount="indefinite" />' +
'</feTurbulence>' +
'<feDisplacementMap in="SourceGraphic" in2="noise" scale="90" xChannelSelector="R" yChannelSelector="G" />' +
'</filter>';
document.body.appendChild(svg);
}
function attach(img) {
var host = img.parentElement;
if (!host || host.dataset.nupzHoverReady) return;
host.dataset.nupzHoverReady = 'true';
host.classList.add('nupz-hero-hover-host');
var canvas = document.createElement('canvas');
canvas.className = 'nupz-hero-hover-canvas';
host.insertBefore(canvas, img.nextSibling);
var ctx = canvas.getContext('2d');
var dpr = Math.min(window.devicePixelRatio || 1, 2);
var w = 0, h = 0;
var mouseX = -999, mouseY = -999;
var isPainting = false;
function resize() {
var rect = host.getBoundingClientRect();
w = rect.width; h = rect.height;
canvas.width = w * dpr;
canvas.height = h * dpr;
ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
resize();
new ResizeObserver(resize).observe(host);
function paintFrame() {
ctx.globalCompositeOperation = 'destination-out';
ctx.fillStyle = 'rgba(0,0,0,' + FADE_ALPHA + ')';
ctx.fillRect(0, 0, w, h);
if (isPainting) {
ctx.globalCompositeOperation = 'source-over';
ctx.save();
ctx.beginPath();
ctx.arc(mouseX, mouseY, BRUSH_RADIUS, 0, Math.PI * 2);
ctx.clip();
ctx.filter = 'blur(3px) url(#nupz-color-smear) saturate(1.6) contrast(1.05)';
ctx.drawImage(img, 0, 0, w, h);
ctx.restore();
}
requestAnimationFrame(paintFrame);
}
requestAnimationFrame(paintFrame);
function move(clientX, clientY) {
var rect = host.getBoundingClientRect();
mouseX = clientX - rect.left;
mouseY = clientY - rect.top;
isPainting = true;
}
host.addEventListener('mousemove', function (e) { move(e.clientX, e.clientY); });
host.addEventListener('mouseleave', function () { isPainting = false; });
host.addEventListener('touchmove', function (e) {
var t = e.touches[0];
move(t.clientX, t.clientY);
}, { passive: true });
host.addEventListener('touchend', function () { isPainting = false; });
}
function init() {
injectFilter();
document.querySelectorAll(SELECTOR).forEach(attach);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
setTimeout(init, 1200);
})();
(function () {
function getAlt(mediaItem) {
if (!mediaItem) return '';
var img = mediaItem.querySelector('img');
return img ? (img.getAttribute('alt') || '').trim() : '';
}
function setup(gallery) {
if (gallery.dataset.nupzCaptionReady) return;
gallery.dataset.nupzCaptionReady = 'true';
var viewer = gallery.querySelector('[id^="GalleryViewer"]');
if (!viewer) return;
function update() {
var items = viewer.querySelectorAll('.product__media-item');
items.forEach(function (item) {
var existing = item.querySelector('.nupz-media-caption');
if (existing) existing.remove();
if (!item.classList.contains('is-active')) return;
var text = getAlt(item);
if (!text) return;
var caption = document.createElement('p');
caption.className = 'nupz-media-caption';
caption.textContent = text;
var mediaWrapper = item.querySelector('.product__media, .media') || item;
mediaWrapper.style.position = mediaWrapper.style.position || 'relative';
mediaWrapper.appendChild(caption);
});
}
viewer.addEventListener('slideChanged', update);
var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
if (thumbnails) {
thumbnails.addEventListener('click', function () {
setTimeout(update, 100);
});
}
update();
}
function init() {
document.querySelectorAll('media-gallery').forEach(setup);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
setTimeout(init, 1200);
})();
(function () {
function findCartForm() {
return document.querySelector('form[data-type="add-to-cart-form"]');
}
function initBundlePicker(root) {
if (root.dataset.nupzInit) return;
root.dataset.nupzInit = '1';
var hint = root.querySelector('.nupz-complete-picker__hint:last-of-type');
var progressTextEl = root.querySelector('#nupz-complete-progress-text, .nupz-complete-picker__hint:first-of-type');
var summary = root.querySelector('.nupz-complete-picker__summary');
var progressFill = root.querySelector('.nupz-complete-picker__progress-fill');
var selects = root.querySelectorAll('.nupz-complete-picker__select');
function prefillFromUrl() {
var params = new URLSearchParams(window.location.search);
var preset = params.get('nupz_preset');
if (!preset) return;
preset = decodeURIComponent(preset);
for (var i = 0; i < selects.length; i++) {
var hasOption = Array.prototype.some.call(selects[i].options, function (o) {
return o.value === preset;
});
if (hasOption && selects[i].value === '') {
selects[i].value = preset;
break;
}
}
}
function syncHiddenInputs() {
var cartForm = findCartForm();
if (!cartForm) return;
cartForm.querySelectorAll('input[data-nupz-property]').forEach(function (el) {
el.remove();
});
selects.forEach(function (s) {
if (s.value === '') return;
var input = document.createElement('input');
input.type = 'hidden';
input.name = 'properties[' + s.dataset.propertyName + ']';
input.value = s.value;
input.setAttribute('data-nupz-property', '1');
cartForm.appendChild(input);
});
}
function update() {
var filled = 0,
chosen = [];
selects.forEach(function (s) {
var slot = s.closest('.nupz-complete-picker__slot');
if (s.value !== '') {
filled++;
chosen.push(s.value);
if (slot) slot.classList.add('is-filled');
} else {
if (slot) slot.classList.remove('is-filled');
}
});
var total = selects.length;
var open = total - filled;
var percent = total > 0 ? Math.round((filled / total) * 100) : 0;
if (progressFill) {
var trackEl = progressFill.parentElement;
var trackWidth = trackEl ? (trackEl.offsetWidth || trackEl.getBoundingClientRect().width) : 0;
progressFill.style.width = (trackWidth * percent / 100) + 'px';
}
if (progressTextEl) progressTextEl.textContent = filled + ' von ' + total + ' Sets ausgewählt';
if (summary) summary.textContent = chosen.length > 0 ? 'Dein Bundle: ' + chosen.join(' + ') : '';
syncHiddenInputs();
var cartForm = findCartForm();
var btn = cartForm ? cartForm.querySelector('[name="add"]') : null;
if (open === 0) {
if (hint) hint.textContent = 'Alle Sets ausgewählt';
if (btn) btn.removeAttribute('disabled');
} else {
if (hint) hint.textContent = 'Bitte wähle noch ' + open + (open === 1 ? ' Set aus' : ' Sets aus');
if (btn) btn.setAttribute('disabled', 'disabled');
}
}
selects.forEach(function (s) {
s.addEventListener('change', update);
});
prefillFromUrl();
update();
var cartForm2 = findCartForm();
if (cartForm2) {
cartForm2.addEventListener('submit', function () {
var removeHandle = new URLSearchParams(window.location.search).get('nupz_remove');
if (!removeHandle) return;
setTimeout(function () {
var cartPromise = window.NupzCart ? window.NupzCart.get() : fetch('/cart.js').then(function (r) { return r.json(); });
cartPromise.then(function (cart) {
var match = cart.items.find(function (i) { return i.handle === removeHandle; });
if (match) {
fetch('/cart/change.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ id: match.key, quantity: 0 }),
}).then(function () {
if (window.NupzCart) window.NupzCart.refresh();
});
}
});
}, 800);
});
}
}
function initAll() {
document.querySelectorAll('.nupz-complete-picker').forEach(initBundlePicker);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initAll);
} else {
initAll();
}
setTimeout(initAll, 800);
setTimeout(initAll, 2000);
})();
(function () {
var overlay = document.getElementById('nupz-quickview-overlay');
var panel = document.getElementById('nupz-quickview-panel');
if (!overlay || !panel) {
return;
}
var imgEl = document.getElementById('nupz-quickview-image');
var titleEl = document.getElementById('nupz-quickview-title');
var priceEl = document.getElementById('nupz-quickview-price');
var descEl = document.getElementById('nupz-quickview-desc');
var linkEl = document.getElementById('nupz-quickview-link');
var addBtn = document.getElementById('nupz-quickview-add');
var closeBtn = document.getElementById('nupz-quickview-close');
var swatchesBox = document.getElementById('nupz-quickview-swatches');
var swatchesRow = document.getElementById('nupz-quickview-swatches-row');
var stockEl = document.getElementById('nupz-quickview-stock');
var currentVariantId = null;
function parseColorMap() {
var map = {};
(window.NupzColorMap || '').split(',').forEach(function (pair) {
var parts = pair.split(':');
if (parts.length === 2) { map[parts[0].trim()] = parts[1].trim(); }
});
return map;
}
function colorForLabel(label, COLORS) {
if (label.indexOf('Classic') === 0) {
var c = label.replace('Classic ', '').trim();
return { background: COLORS[c] || '#888' };
} else if (label.indexOf('Duo') === 0) {
var parts = label.replace('Duo ', '').split('/');
var c1 = COLORS[parts[0].trim()] || '#888';
var c2 = COLORS[parts[1].trim()] || '#888';
return { background: 'linear-gradient(90deg,' + c1 + ' 50%,' + c2 + ' 50%)' };
} else if (label.indexOf('Akzent') === 0) {
var parts2 = label.replace('Akzent ', '').split('-');
var base = COLORS[parts2[0].trim()] || '#888';
var ring = COLORS[parts2[1].trim()] || '#888';
return { background: base, boxShadow: 'inset 0 0 0 3px ' + ring };
}
return { background: '#888' };
}
function open(data) {
imgEl.src = data.image;
titleEl.textContent = data.title;
priceEl.textContent = data.price;
if (descEl) descEl.textContent = data.desc || '';
if (linkEl && data.url) linkEl.href = data.url;
if (stockEl) stockEl.textContent = data.stock || '';
if (swatchesRow && swatchesBox) {
swatchesRow.innerHTML = '';
var siblings = (data.siblings || '').split(';').filter(Boolean);
if (siblings.length > 1) {
var COLORS = parseColorMap();
siblings.forEach(function (entry) {
var parts = entry.split('|');
var label = parts[0];
var url = parts[1];
var a = document.createElement('a');
a.className = 'nupz-quickview-swatch' + (data.currentUrl === url ? ' is-current' : '');
a.href = url;
a.title = label;
var inner = document.createElement('span');
inner.className = 'nupz-quickview-swatch__inner';
var style = colorForLabel(label, COLORS);
inner.style.background = style.background;
if (style.boxShadow) inner.style.boxShadow = style.boxShadow;
a.appendChild(inner);
swatchesRow.appendChild(a);
});
swatchesBox.style.display = 'block';
} else {
swatchesBox.style.display = 'none';
}
}
currentVariantId = data.variantId;
addBtn.textContent = 'In den Warenkorb';
addBtn.classList.remove('is-loading');
overlay.classList.add('is-open');
panel.classList.add('is-open');
}
function close() {
overlay.classList.remove('is-open');
panel.classList.remove('is-open');
}
overlay.addEventListener('click', close);
closeBtn.addEventListener('click', close);
addBtn.addEventListener('click', function () {
if (!currentVariantId || addBtn.classList.contains('is-loading')) return;
addBtn.classList.add('is-loading');
addBtn.textContent = 'Wird hinzugefügt …';
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ items: [{ id: parseInt(currentVariantId, 10), quantity: 1 }] }),
})
.then(function (res) {
return res.json().then(function (data) {
if (!res.ok) { throw data; }
return data;
});
})
.then(function () {
addBtn.classList.remove('is-loading');
addBtn.textContent = 'Hinzugefügt ✓';
if (window.NupzCart) { window.NupzCart.refresh(); }
setTimeout(close, 900);
})
.catch(function (err) {
addBtn.classList.remove('is-loading');
addBtn.textContent = 'In den Warenkorb';
var msg = (err && (err.description || err.message)) ? (err.description || err.message) : 'Fehler beim Hinzufügen';
alert(msg);
});
});
window.NupzOpenQuickView = open;
})();
(function () {
function renderShippingBar(cart) {
var boxes = document.querySelectorAll('#nupz-cart-shipping-bar');
if (!boxes.length) return;
boxes.forEach(function (box) {
var track = box.querySelector('#nupz-cart-shipping-bar-track, .nupz-cart-shipping-bar__track');
var text = box.querySelector('#nupz-cart-shipping-bar-text, .nupz-cart-shipping-bar__text');
var fill = box.querySelector('#nupz-cart-shipping-bar-fill, .nupz-cart-shipping-bar__fill');
if (!track || !text || !fill) return;
var threshold = parseInt(box.dataset.threshold, 10) || 3899;
var pageShowsEmpty = !!document.querySelector('cart-items.is-empty');
if (cart.items.length === 0 || pageShowsEmpty) {
box.style.setProperty('display', 'none', 'important');
return;
}
box.style.setProperty('display', 'block', 'important');
var total = cart.total_price;
var percent = Math.min(100, Math.round((total / threshold) * 100));
var trackWidth = track.offsetWidth || track.getBoundingClientRect().width;
fill.style.width = (trackWidth * percent / 100) + 'px';
if (total >= threshold) {
text.innerHTML = '🎉 <strong>Kostenloser Versand freigeschaltet</strong>';
} else {
var remaining = ((threshold - total) / 100).toFixed(2).replace('.', ',');
text.innerHTML = 'Noch <strong>' + remaining + ' €</strong> bis zum kostenlosen Versand';
}
});
}
function initShippingBar() {
if (!document.getElementById('nupz-cart-shipping-bar')) return;
if (window.NupzCart) {
window.NupzCart.refresh().then(renderShippingBar);
}
}
document.addEventListener('nupz:cart-updated', function (e) {
renderShippingBar(e.detail);
});
window.addEventListener('resize', function () {
if (window.NupzCart) window.NupzCart.refresh().then(renderShippingBar);
});
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initShippingBar);
} else {
initShippingBar();
}
setTimeout(initShippingBar, 500);
setTimeout(initShippingBar, 1500);
})();